import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import style from './Copyright.scss'

function Copyright({ className }) {
  const componentClass = cx(style.copyright, { [className]: className })

  return (
    <p className={componentClass}>
      Certifique-se de preencher com e-mail e telefones válidos, já que seus dados são consultados pela nossa equipe.
      Por isso, a Hi Platform reserva o direito de desativar contas cujos dados estejam incorretos. Ao avançar, você
      está concordando com nossos{' '}
      <a
        href="https://release.hiplatform.com/2018/02/16/termos-de-uso-da-plataforma-social/"
        title="Abrir termos de uso"
        target="_blank"
      >
        termos de uso
      </a>
      . Todas os planos pagos oferecem auxílio de uma equipe de suporte e de gerente de contas.
    </p>
  )
}

Copyright.propTypes = {
  className: PropTypes.string,
}

export default Copyright



// WEBPACK FOOTER //
// ./src/components/Common/Copyright.js